import { Box, Card, CardContent, Typography } from "@mui/material";
import { AppLineChart } from "../Charts/LineChart";

export const TotalOrders = ({
  totalOrdersCount,
  isLoading,
  xAxisData,
  yAxisData,
  dateDifference,
  isCurrency,
}: {
  totalOrdersCount: number;
  isLoading: boolean;
  xAxisData: string[] | Date[] | number[];
  yAxisData: any[];
  dateDifference: number;
  isCurrency: boolean;
}) => {
  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" fontWeight={"bold"}>
            Total Orders =&nbsp;
            <Typography fontWeight={"bold"}> {totalOrdersCount}</Typography>
          </Box>
        </Box>
        <AppLineChart
          isLoading={isLoading}
          xAxisData={xAxisData}
          yAxisData={yAxisData}
          dateDifference={dateDifference}
          isCurrency={isCurrency}
        />
      </CardContent>
    </Card>
  );
};
